import { BrowserStorageKey } from "../../../../hooks/useBrowserStorage";
import {
  useLocalStorage,
  useLocalStorageValue,
} from "../../../../hooks/useLocalStorage";

type SuggestionDetailEditorPreferences = {
  view: "inline" | "side-by-side";
  wordWrap: "off" | "on";
};

export const DEFAULT_SUGGESTION_DETAIL_EDITOR_PREFERENCES: SuggestionDetailEditorPreferences =
  {
    view: "inline",
    wordWrap: "on",
  } as const;

export const SUGGESTION_DETAIL_EDITOR_PREFERENCES: BrowserStorageKey<SuggestionDetailEditorPreferences> =
  {
    keyName: "suggestion_detail_editor_preferences",
    default: DEFAULT_SUGGESTION_DETAIL_EDITOR_PREFERENCES,
  };

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- infer
export const useSuggestionDetailEditorPreferencesValue = () =>
  useLocalStorageValue(SUGGESTION_DETAIL_EDITOR_PREFERENCES);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type -- infer
export const useSuggestionDetailEditorPreferences = () =>
  useLocalStorage(SUGGESTION_DETAIL_EDITOR_PREFERENCES);
